var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSoundOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-sound-on",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.279,
    height: 22.262,
    viewBox: "0 0 25.279 22.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffbf3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-1",
    d: "M37.462,25.27a.774.774,0,0,0-.8.045l-7.806,5.309H25.2a3.393,3.393,0,0,0-3.39,3.39v4.6A3.393,3.393,0,0,0,25.2,42h3.659l7.806,5.309a.766.766,0,0,0,.435.135.791.791,0,0,0,.363-.09.774.774,0,0,0,.413-.686V25.956A.765.765,0,0,0,37.462,25.27ZM36.324,45.195l-6.793-4.618a.766.766,0,0,0-.435-.135H25.2a1.836,1.836,0,0,1-1.834-1.834v-4.6A1.836,1.836,0,0,1,25.2,32.174h3.9a.745.745,0,0,0,.435-.135l6.793-4.618Z",
    transform: "translate(-21.81 -25.18)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M70.261,35.635a9.968,9.968,0,0,0-3.829-4.524A.776.776,0,0,0,65.6,32.42a8.409,8.409,0,0,1,0,14.186.776.776,0,0,0,.417,1.43.788.788,0,0,0,.417-.121,10.055,10.055,0,0,0,1.695-1.359,9.965,9.965,0,0,0,2.134-10.922Z",
    transform: "translate(-45.767 -28.385)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M65.136,43.11A6.628,6.628,0,0,0,62,37.631a.776.776,0,0,0-.834,1.309,4.806,4.806,0,0,1,0,8.34.776.776,0,0,0,.417,1.43A.788.788,0,0,0,62,48.589,6.628,6.628,0,0,0,65.136,43.11Z",
    transform: "translate(-43.323 -31.981)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOn);
export default __webpack_public_path__ + "static/media/icon-sound-on.b1e993014c30c6d12fdf2ce6976df357.svg";
export { ForwardRef as ReactComponent };